<template>
  <v-container fluid class="py-0 px-0">
    <!-- Modal de Protocolo de Acesso -->
    <v-dialog v-model="protocolDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          Protocolo de Acesso
        </v-card-title>
        <v-card-text>
          <p class="mb-4">Este exame está protegido. Digite o protocolo de acesso fornecido para visualizar.</p>
          <v-text-field
            v-model="protocolInput"
            label="Digite o protocolo"
            :error-messages="protocolError"
            @keyup.enter="validateProtocol"
            maxlength="6"
            class="mt-4"
            outlined
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="validateProtocol"
            :loading="validatingProtocol"
          >
            Acessar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Conteúdo principal (só exibe se tiver acesso) -->
    <template v-if="accessGranted">
      <!-- Resto do template existente -->
      <v-layout row wrap style="margin-top: 4.5rem; height: 1.1rem;">
        <v-toolbar app fixed class="toolbar-exame">
          <img src="/static/logo.png" weight="142" height="60"/>
          <v-spacer></v-spacer>
          <h6 class="patientName">Olá, {{patientName}}</h6>
          <v-spacer></v-spacer>
          <!-- <v-btn class="exitButton" style="background-color:#051a30;">Sair</v-btn> -->
        </v-toolbar>
      </v-layout>

      <!-- Header Exame -->
      <v-layout row wrap class="header-exame">
        <!--<v-flex xs6 md2 style="align-self: center;">
          <a style="display: flex; align-items: start;"><v-icon href="#/patients" style="color: white;">chevron_left</v-icon>Voltar para exames</a>
        </v-flex>-->
        <v-flex xs4 md2 style="align-self: end; padding-left: 1rem;">
          <p>Data do exame: {{ examDate }}</p>
        </v-flex>
        <v-flex xs4 md2 style="align-self: end;">
          <p>Código do exame: {{ examAN }}</p>
        </v-flex>
        <v-flex xs4 md2 style="align-self: end;" v-if="protocolInput">
          <p>Protocolo de acesso: {{ protocolInput }}</p>
        </v-flex>
      </v-layout>

      <!-- Banner Feature -->
      <v-layout row>
        <v-flex class="banner-feature">
          <p>Temos e-books sobre gestação que podem te interessar.<v-btn class="btn-acess" @click="toInfo()">Saiba mais</v-btn></p>
        </v-flex>
      </v-layout>

      <!-- Seção de Laudo, imagens e video -->
      <v-layout row wrap class="section-exame">
        <!-- Coluna Laudo -->
        <v-flex 
          :class="{
            'xs12': true,
            'md8': hasMedias,
            'md12': !hasMedias,
            'coluna-laudo': true
          }"
        >
          <v-btn class="badge-rounded-pill" rounded>Laudo</v-btn>
          <v-btn v-if="data.status=='PUBLICADO'" class="btn-acess" :href="urlReport" target="_blank">
            <v-icon left>download</v-icon>
            Baixar Exame
          </v-btn>
          
          <!-- Nova mensagem quando laudo não estiver publicado -->
          <v-card v-if="data.status !== 'PUBLICADO'" class="mt-4 pa-4">
            <v-alert
              color="warning"
              icon="warning"
              value="true"
              outline
              elevation="2"
            >
              <h3 class="mb-3 warning--text text--darken-2">Laudo em Processamento</h3>
              <p class="mb-0 grey--text text--darken-2">
                O laudo do seu exame <strong class="warning--text text--darken-2">{{ examTitle }}</strong> está em fase de elaboração. Assim que for finalizado e disponibilizado, você poderá acessá-lo por aqui.
                Se precisar de mais informações ou tiver dúvidas, entre em contato com a clínica.
              </p>
              <v-divider class="my-3"></v-divider>
              <div class="info-section lighten-5">
                <p class="caption mb-1" v-if="doctorName">
                  <v-icon small class="mr-1 warning--text">fas fa-user-md</v-icon>
                  <span class="grey--text text--darken-2">Dr(a). {{ doctorName }}</span>
                </p>
                <p class="caption mb-1" v-if="doctorIdentity">
                  <v-icon small class="mr-1 warning--text">fas fa-id-card</v-icon>
                  <span class="grey--text text--darken-2">CRM: {{ doctorIdentity }}</span>
                </p>
                <p class="caption mb-0" v-if="companyName">
                  <v-icon small class="mr-1 warning--text">fas fa-hospital</v-icon>
                  <span class="grey--text text--darken-2">{{ companyName }}</span>
                </p>
              </div>
            </v-alert>
          </v-card>

          <!-- Iframe do laudo apenas quando estiver publicado -->
          <iframe 
            v-else
            class="laudo-exame" 
            :src="urlReport" 
            width="100%" 
            type="application/pdf" 
            height="1000rem"
          ></iframe>
        </v-flex>
          <!--<v-layout column >
            <v-flex md1 class="btn-controll">
              <v-btn title="Recolher"><v-icon class="mx-2">last_page</v-icon></v-btn>
            </v-flex>
          </v-layout> -->
        <!-- Coluna Midias -->
        <v-flex 
          v-if="hasMedias"
          xs12
          md4
          class="midias-container"
        >
          <v-layout column class="container-exames-midias">
            <!-- Video do exame -->
            <v-flex v-if="hasVideos" class="exame-video">
              <v-btn class="badge-rounded-pill">Vídeo</v-btn>
              <v-btn 
                v-if="canShare"
                class="btn-acess" 
                @click="shareVideo"
              >
                <v-icon left>share</v-icon>
                Compartilhar
              </v-btn>
              <v-btn
                v-else
                class="btn-acess" 
                @click="shareVideo" 
                :href="examUrl"
                :target="'_blank'"
              >
                <v-icon left>open_in_new</v-icon>
                Compartilhar
              </v-btn>
              <!--<iframe class="rounded-0 iframe-video-exame" src="https://www.youtube.com/embed/wv8wT3OuXP4" type="video/mp4" frameborder="0" -->
                <v-flex v-for="(video, i) in listVideos" :key="i"  style="padding:0px" md12 x12>
                <v-card>
                  <iframe
                  :src="video"
                  width="100%"
                  height="300px"
                  style="border: 0px"
                  allowfullscreen="allowfullscreen"
                  mozallowfullscreen="mozallowfullscreen"
                  msallowfullscreen="msallowfullscreen"
                  oallowfullscreen="oallowfullscreen"
                  webkitallowfullscreen="webkitallowfullscreen"/>
                </v-card>
              </v-flex>
            </v-flex>
            
            <!-- Imagens do exame -->
            <v-flex v-if="hasImages">
              <v-btn class="badge-rounded-pill">Imagens</v-btn>
              <v-layout row="row" wrap="wrap" style="justify-content: center">
                <v-flex md12 xs12>
                  <v-card flat="flat" tile="tile">
                    <!--<v-img :src="listImageURL[0]" @click="slideIndex = i" @load="imgLoaded=true" style="height: 100%; width: 100%; background-color: black;">
                    </v-img>-->
                  </v-card>
                </v-flex>
                <v-flex md12 xs12>
                  <v-card flat="flat" tile="tile">
                    <v-img v-if="listImageURL.length > 0" :src="listImageURL[0]" @click="slideIndex = i" @load="imgLoaded=true" style="height: 100%; width: 100%; background-color: black;">
                    </v-img>
                  </v-card>
                </v-flex>
                <vue-gallery :images="listImageURL" :index="slideIndex" @close="slideIndex = null"></vue-gallery>
                <v-label v-if="imgLoaded" class="ImageCount" style="background-color: lightgray">{{listImageURL.length}} Imagens</v-label>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- Section Card -->
      <v-layout row class="section-cards" id="section-card">
        <v-flex>
          <h4 class="text-center">Preparamos estes conteúdos para você</h4>
          <v-icon class="button-down" style="">expand_more</v-icon>

          <v-container>
          <v-layout row wrap class="section-cards-container">
            <!-- Card 1 -->
            <v-flex xs12 md7 lg5>
              <v-card class="card">
                <v-img class="card-img" src="/static/book-alimentacao.png" alt="Guarde esse momento muito especial"></v-img>
                <v-card-text>
                  <h5 class="cards-title">Conheça os Ultrabooks!</h5>
                  <p class="cards-text">Leia os ebooks da UltraHealth, veja dicas para cuidar da sua saúde e do seu bebê com mais tranquilidade e confiança.</p>
                  <v-btn class="cards-button" href="https://hotmart.com/pt-br/marketplace/produtos/cuidados-com-alimentacao-na-gestacao/G80757405T?ref=S89680158P" target="_blank">LER AGORA</v-btn>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Card 2 -->
            <!--<v-flex xs12 md5 lg5>
              <v-card class="card">
                <v-img class="card-img" src="/static/3D-baby.png" alt="Guarde esse momento muito especial"></v-img>
                <v-card-text>
                  <h5 class="cards-title">Guarde esse momento muito especial</h5>
                  <p class="cards-text">Saiba como a tecnologia 3D pode revolucionar a forma como você acompanha a sua gestação.</p>
                  <v-btn class="cards-button">SABER MAIS</v-btn>
                </v-card-text>
              </v-card>
            </v-flex>-->
          </v-layout>
        </v-container>
        </v-flex>
      </v-layout>

      <!-- Footer -->
      <v-footer class="footer-content">
        <v-container fluid class="footer-content-container">
          <v-layout row wrap>
            <v-flex xs12 md3 >
              <img src="/static/logo-uhc-fundo-escuro-300x164.png" weight="130rem" height="130rem" class="img-logo" alt="ULTRAHEALTH CARE" title="ULTRAHEALTH CARE"/>
              <p>Somos uma empresa formada por uma equipe de médicos, na área de medicina fetal, e profissionais na área da Tecnologia da Informação especializados na área médica.</p>
            </v-flex>
            <v-flex xs12 md3>
              <h3 class="fw-bolder ml-3 mt-3">Produtos</h3>
              <v-list class="footer-content">
                <v-list-tile><a href="https://ultrahealthcare.com.br/ultrafetal/" alt="UltraFetal" title="Página UltraFetal" target="_blank">UltraFetal</a></v-list-tile>
                <v-list-tile><a href="https://ultrahealthcare.com.br/ultravideo/" alt="UltraVideo" title="Página UltraVideo" target="_blank">UltraVideo</a></v-list-tile>
              </v-list>
            </v-flex>
            <v-flex xs12 md3>
              <h3 class="fw-bolder ml-3 mt-3">Contato</h3>
              <v-list class="footer-content">
                <v-list-tile><v-icon class="list-icons">location_on</v-icon> Florianópolis-SC-Brasil</v-list-tile>
                <v-list-tile><v-icon class="list-icons">call</v-icon> +55 48 99660-5206</v-list-tile>
                <v-list-tile><v-icon class="list-icons">send</v-icon> vendas@ultrahealth.care</v-list-tile>
                <v-list-tile><v-icon class="list-icons">schedule</v-icon> Seg. a sex. das 08h às 18h</v-list-tile>
              </v-list>
            </v-flex>
            <v-flex xs12 md3>
              <h3 class="fw-bolder ml-3 mt-3">Social</h3>
              <v-list class="footer-content">
                <v-list-tile><a href="https://www.linkedin.com/company/ultrahc/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FF5B6E" class="bi bi-linkedin" viewBox="0 0 16 16">
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                  </svg> /ultrahc</a></v-list-tile>
                <v-list-tile><a href="https://www.facebook.com/ultrahealthcaretech" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FF5B6E" class="bi bi-facebook" viewBox="0 0 16 16">
                  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                  </svg> /sistemaultrahealthcare</a></v-list-tile>
                <v-list-tile><a href="https://www.instagram.com/ultrahealthcare_tech/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FF5B6E" class="bi bi-instagram" viewBox="0 0 16 16">
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                  </svg> /ultra_health_care</a></v-list-tile>
                <v-list-tile><a href="https://www.youtube.com/@ultrahealth_care" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FF5B6E" class="bi bi-youtube" viewBox="0 0 16 16">
                  <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"/>
                  </svg> /@ultrahealth_care</a></v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
          <v-layout align-end>
            <v-flex xs12 md12 class="d-flex justify-between">
              <div class="copyright">
                <h3>&copy; Copyright <strong><span>ULTRAHEALTHCARE TECNOLOGIA LTDA</span></strong>.</h3>
              </div>
              <v-spacer></v-spacer>
              <v-flex sm1>
                <v-icon class=" justify-end icon-container" @click="toTop()">arrow_upward</v-icon>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-footer>
    </template>
  </v-container>
</template>

<script>
import 'vue-pdf-app/dist/icons/main.css'
import VuePdfApp from 'vue-pdf-app'
import moment from 'moment'
import VueGallery from 'vue-gallery'
import axios from 'axios'
const URL_BASE_REPORT = 'https://report-server-dev-dot-ultracarebr.rj.r.appspot.com/report/'
const URL_BASE_PATIENT_PORTAL = 'https://app.ultrahealth.care/functions/patientPortal'
// const URL_BASE_PATIENT_PORTAL = 'http://localhost:5000/ultracarebr/us-central1/patientPortal'

export default {
  name: 'PortalPaciente',
  components: {
    VuePdfApp,
    VueGallery
  },
  props: {
    id: {
      required: false
    }
  },
  computed: {
    urlReport () {
      return (URL_BASE_REPORT && this.id) ? (URL_BASE_REPORT + this.id) : ''
    },
    listVideos () {
      return this.data && this.data.videosList ? this.data.videosList : ''
    },
    patientName () {
      return this.data && this.data.patient && this.data.patient.patientName ? this.data.patient.patientName : ''
    },
    patId () {
      return this.data && this.data.patient && this.data.patient.patId ? this.data.patient.patId : ''
    },
    examDate () {
      return this.data && this.data.studyDate ? moment(this.data.studyDate).format('DD/MM/YYYY') : ''
    },
    examAN () {
      return this.data && this.data.studiesList ? Object.keys(this.data.studiesList).toString() : ''
    },
    examUrl () {
      if (this.data && this.data.videosList && this.data.videosList.length > 0) {
        let video = this.data.videosList[0]
        return video.replace('/player', '/exame')
      }
    },
    examTitle () {
      return (this.data && this.data.forms && this.data.forms.title) ? this.data.forms.title : 'Não especificado'
    },
    doctorName () {
      return this.data && this.data.doctorPerform ? this.data.doctorPerform.name : ''
    },
    doctorIdentity () {
      return this.data && this.data.doctorPerform ? this.data.doctorPerform.identity : ''
    },
    companyName () {
      return this.data && this.data.company ? this.data.company.nameFull : ''
    },
    hasVideos () {
      return this.listVideos && this.listVideos.length > 0
    },
    hasImages () {
      return this.listImageURL && this.listImageURL.length > 0
    },
    hasMedias () {
      return this.hasVideos || this.hasImages
    }
  },

  data () {
    return {
      data: [{}],
      listImageURL: [{}],
      loaded: false,
      imgLoaded: false,
      slideIndex: null,
      protocolDialog: false,
      protocolInput: '',
      protocolError: '',
      validatingProtocol: false,
      accessGranted: false,
      canShare: false
    }
  },
  async mounted () {
    this.checkShareSupport()
    try {
      const response = await axios.get(`${URL_BASE_PATIENT_PORTAL}?id=${this.id}&checkProtocol=true`)
      if (response.data.requiresProtocol) {
        // Preenche o input com o protocolo salvo (se existir)
        const savedProtocol = this.getSavedProtocol()
        if (savedProtocol) {
          this.protocolInput = savedProtocol
          // Valida automaticamente o protocolo salvo
          this.validateProtocol()
        } else {
          this.protocolDialog = true
        }
      } else {
        this.protocolDialog = false
        this.accessGranted = true
        this.data = response.data
        this.listImageURL = response.data.imagesList
      }
    } catch (error) {
      console.error('Erro ao verificar protocolo:', error)
    }
  },

  methods: {
    async validateProtocol () {
      if (!this.protocolInput) {
        this.protocolError = 'Digite o protocolo de acesso'
        return
      }

      this.validatingProtocol = true
      this.protocolError = ''

      try {
        const response = await axios.get(
          `${URL_BASE_PATIENT_PORTAL}?id=${this.id}&protocol=${this.protocolInput}`
        )

        if (response.data.accessGranted) {
          // Salva o protocolo no localStorage
          localStorage.setItem(`protocol-${this.id}`, this.protocolInput)
          this.accessGranted = true
          this.protocolDialog = false
          this.data = response.data
          this.listImageURL = response.data.imagesList
        } else {
          this.protocolError = 'Protocolo inválido'
        }
      } catch (error) {
        this.protocolDialog = true
        console.error('Erro ao validar protocolo:', error)
        this.protocolError = 'Erro ao validar protocolo'
      } finally {
        this.validatingProtocol = false
      }
    },
    toTop () {
      // vai para o topo da página
      this.$vuetify.goTo(0)
    },
    toInfo () {
      const elemento = document.getElementById('section-card')
      const posicao = elemento.offsetTop

      // Rola a página para o meio suavemente
      window.scrollTo({
        top: posicao,
        behavior: 'smooth'
      })
    },
    // Método para recuperar protocolo do localStorage
    getSavedProtocol () {
      return localStorage.getItem(`protocol-${this.id}`)
    },
    async shareVideo (event) {
      if (!this.canShare) return // deixa o comportamento padrão do href acontecer

      event.preventDefault()
      try {
        await navigator.share({
          title: `Gravação do exame - ${this.patientName}`,
          text: 'Confira o vídeo do exame',
          url: this.examUrl
        })
      } catch (error) {
        // Se der erro no compartilhamento, abre o link direto
        window.open(this.examUrl, '_blank')
      }
    },
    checkShareSupport () {
      this.canShare = !!navigator.share
    }
  },

  watch: {
    protocolInput (val) {
      this.protocolInput = val.toUpperCase()
      this.protocolError = ''
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family=Source+Sans+Pro:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400;1,600;1,700&display=swap" rel="stylesheet');

  small {
    font-size: 70%;
  }
  .icon{
    justify-content: center;
  }

  .listContent{
    overflow: visible!important;
  }

  .pdfDocument{
    height: 100%;
    min-height: 75vh;
    width: -webkit-fill-available;
    width: -moz-available;
    width: -o-available;
    width: intrinsic;
    width: 100%;
  }
   .loading {
    position: absolute;
    top: 50%;
    left: 40%;
    transform: translate(-50%, -50%);
  }
  .toolbar-exame {
    background: #F6F9FA !important;
    padding-right: calc(12rem) !important;
    padding-left: calc(12rem) !important;
    height: 5.6rem;
  }
  .v-toolbar__content {
    height: 5.6rem !important;
    padding: 2.6rem !important;
  }
  .patientName {
    font-size: 1.1rem;
    font-family:Lexend, sans-serif;
    line-height: 1.2;
    font-weight: 500;
  }
  .exitButton {
    color:white;
    font-family:Lexend, sans-serif;
    font-size: 16px;
    margin-right: 20px;
    padding: 8px 23px;
  }
  .header-exame {
    background-color: #103355;
    color: white;
    font-size: 12px;
    height: 45px;
  }
  .banner-feature {
    background-image: linear-gradient(rgba(140, 248, 226, 0.8), rgba(255, 255, 255, 0.9));
    text-align: end;
    color: #103355 !important;
    font-weight: 700 !important;
    font-size: 1rem;

  }
  .section-exame {
    background: url('../../static/hero-bg.png'), #CCD8DF ;
    background-size: cover;
  }

  .coluna-laudo{
    margin-right: 0;
    padding: 10px;
  }

  .btn-controll {
    margin-right: 10px;
    padding-top: 20px;
  }

  .btn-controll button{
    background: white;
    width: 20px;
    height: 20px;
    padding: 20px;
    border-radius: 10px;
    border: 0;
    box-shadow: rgba(9, 30, 66, 0.08) 0px 0px 0px 1px, rgba(9, 30, 66, 0.08) 0px 2px 4px 1px;
    color: #051a30;
    cursor: pointer;
    transition: background-color 100ms linear 0s, color 100ms linear 0s, opacity 350ms cubic-bezier(0.2, 0, 0, 1) 0s;
    font-size: 20px;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .container-exames-midias {
    width: 100%;
    padding: 0 10px 20px 20px;
    border-left: 1px solid #d1cfcf;
    border-bottom: 1px solid #d1cfcf;
    background: rgba(255,255,255, 0.3);
    padding-top: 20px;
    max-height: 115vh;
    border-radius: 5px;
    overflow: hidden;
    overflow-y: auto;
  }
  .iframe-video-exame{
    width: 100%;
    height: 37vh;
  }
  .exame-video{
    width: 100%;
    display: block;
  }
  .exame-imgs{
    width: 100%;
    height: auto;
    background: var(--color-gray-light);
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;
    margin-bottom: 20px;
  }
  .text-center {
    font-weight: 700;
    color: #9F1D2C;
    text-align: center !important;
    font-size: calc(1.275rem + .3vw);
    margin-top: 0;
    margin-bottom: 0.5rem;
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .btn-acess {
    background-color:#FF5B6E !important;
    color: white;
    border-radius: 0.25rem;
  }
  .badge-rounded-pill {
    color: white;
    background-color: rgb(72, 86, 100) !important;
    border-radius: 2rem;
    font-weight: bold;
    text-transform: capitalize;
  }
  .button-down {
    display: block;
    font-style: normal;
    font-weight: normal !important;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
    font-size: calc(1.375rem + 1.5vw) !important;
    text-align: center !important;
    align-content: center !important;
    color: #1a1f24;
  }
  .section-cards-container{
    display: flex;
    justify-content: center;
    padding: 2.1rem;
    background-color: #F8F9FA;
  }
  .section-cards .card{
    width: 30rem;
  }
  .card-img{
    height: 17.1rem;
    width: 30rem;

  }
  .cards-title {
    font-size: 30px;
    color: #103355;
    font-weight: 600;
    font-family: 'Lexend', sans-serif;
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }
  .cards-text {
    margin-top: 0;
    margin-bottom: 1rem;
    box-sizing: border-box;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    text-align: left;
    color: #1a1f24;
    font-family: 'Open Sans', system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  }
  .cards-button {
    background-color: #103355 !important;
    color: #fff;
  }
  .footer-content {
    background: #051a30;
    color: #ffffff;
  }
  .footer-content-container {
    background: #051a30;
    color: #ffffff;
    padding-right: calc(18rem) !important;
    padding-left: calc(18rem) !important;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  .list-icons {
    color: #FF5B6E !important;
  }
  .copyright {
    color: #ffffff;
    font-size: 0.875rem;
    display: flex !important;
  }
  .icon-container {
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: #132d46 !important;
}

  @media all and (max-width: 1024px) {
    .btn-controll {
      display: none;
    }
    .footer-content-container {
    background: #051a30;
    color: #ffffff;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  }

  @media all and (max-width: 800px) {
    .listContent {
      font-size: 70%;
    }
   .loading {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
@media (max-width: 640px) {
  .banner-feature {
    background-image: linear-gradient(rgba(140, 248, 226, 0.8), rgba(255, 255, 255, 0.9));
    text-align: start;
  }
  .footer-content-container {
    background: #051a30;
    color: #ffffff;
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .toolbar-exame {
    background: #F6F9FA !important;
    padding-right: 0rem !important;
    padding-left: 0rem !important;
    height: 5.6rem;
  }
  .card-img{
    height: 17.1rem;
    width: 22rem;
  }
  .section-cards-container{
    display: flex;
    justify-content: center;
    padding: 2.1rem;
    background-color: #F8F9FA;
  }
  .section-cards .card{
    width: 22rem;
  }
  .btn-controll {
    display: none;
  }
}

@media (max-width: 350px) {
  .card-img{
    height: 17.1rem;
    width: 20rem;
  }
  .section-cards-container{
    display: flex;
    justify-content: center;
    padding: 0rem;
    background-color: #F8F9FA;
  }
  .section-cards .card{
    width: 20rem;
  }
}
.laudo-exame {
  margin-top: 20px;
}

.v-alert {
  background-color: #f8f9fa;
}

.v-alert h3 {
  font-weight: 500;
}

.v-alert p {
  font-size: 16px;
  line-height: 1.6;
}

.info-section {
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
}

.info-section .caption {
  color: #546e7a;
  font-size: 0.875rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/PatientPortal2.vue